import { RouteNames } from '../../types/RouteNames'

export const authlessDynamicRoutes = {
  responsibleMedicalRecordFill: <T extends string>(id: T) =>
    `/patient-medical-record/${id}`
}

export const authlessRouteNames = {
  responsibleMedicalRecordFill:
    authlessDynamicRoutes.responsibleMedicalRecordFill(':id')
} as const satisfies RouteNames
